import React from "react";

export const Pokebola = ({ animate }) => {
  return <div className={`pokeball ${animate ? "throw" : ""}`}></div>;
};
export default Pokebola;
